module.exports = __webpack_public_path__ + "static/media/arrow-up.0a83ba38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow-up.svg
// module id = 1217
// module chunks = 0